/**
 * Updates the savings badge text based on quantity and subscription state.
 * Replicates the logic from your Liquid file to ensure instant UI feedback.
 */
function updateVariantSavings(variant, isSubscriptionActive) {
  const saveElement = variant.querySelector('.productVariantSave');
  const quantity = variant.getAttribute('quantity');

  if (!saveElement) return;

  if (isSubscriptionActive) {
    // Subscription Logic
    saveElement.style.fontWeight = 'bold';
    saveElement.classList.remove('empty');
    if (quantity === "1") saveElement.textContent = "Save 5%";
    else if (quantity === "2") saveElement.textContent = "Save 7%";
    else if (quantity === "3") saveElement.textContent = "Save 17%";
  } else {
    // One-Time Purchase Logic
    saveElement.style.fontWeight = '';
    
    if (quantity === "1") {
      saveElement.textContent = "-";
      saveElement.classList.add('empty');
    } else if (quantity === "2") {
      saveElement.textContent = "Save 5%";
      saveElement.classList.remove('empty');
    } else if (quantity === "3") {
      saveElement.textContent = "Save 10%";
      saveElement.classList.remove('empty');
    }
  }
}

/**
 * Main function triggered by onclick="selectVariant(this)" in HTML
 */
window.selectVariant = function(variantElement) {
  // 1. Find the inputs
  const quantityInput = document.querySelector('input[name="quantity"]'); 
  const productVariants = document.querySelectorAll(".productVariant");
  const subscriptionToggle = document.getElementById('subscriptionToggle');
  const isSubActive = subscriptionToggle ? subscriptionToggle.checked : false;

  // 2. Visual Updates: Handle "active" classes
  productVariants.forEach(function(variant) {
    variant.classList.remove("active");
  });
  variantElement.classList.add("active");

  // 3. Update the Savings Text immediately for this clicked variant
  updateVariantSavings(variantElement, isSubActive);

  // 4. Logic Update: Change the hidden input value
  if (quantityInput) {
    const newQuantity = variantElement.getAttribute("quantity");
    
    // Update value and attribute for consistency
    quantityInput.value = newQuantity;
    quantityInput.setAttribute("value", newQuantity); 

    // 5. CRITICAL: Trigger the 'change' event
    // This notifies cart.js, Loop widgets, and sticky bars that quantity changed
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
};

document.addEventListener("DOMContentLoaded", function () {
  // Initialize Default State on Load
  const defaultVariant = document.querySelector(".productVariant.active");
  const quantityInput = document.querySelector('input[name="quantity"]');
  const subscriptionToggle = document.getElementById('subscriptionToggle');
  
  // Find the parent form of the input (used for the anti-reset logic)
  const productForm = quantityInput ? quantityInput.closest('form') : null;

  // Sync initial input value
  if (defaultVariant && quantityInput) {
    const defaultQuantity = defaultVariant.getAttribute("quantity");
    quantityInput.value = defaultQuantity;
  }

  // Add listener to Toggle to refresh the active variant's text if user toggles subscription
  if (subscriptionToggle) {
    subscriptionToggle.addEventListener('change', function() {
      const activeVariant = document.querySelector(".productVariant.active");
      if (activeVariant) {
        updateVariantSavings(activeVariant, this.checked);
      }
    });
  }

});